import React from "react";
import SwiperCore, { Navigation, A11y, Zoom, SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { getCloudflareImageSrcSet } from "@pepdirect/helpers/cloudflareImages";
import cx from "classnames";
import st from "./images.module.scss";
import { ImgFromCDN } from "@pepdirect/ui/ImgFromCDN";
import { ItemBySlugQuery } from "services/graphql/generated";

SwiperCore.use([Navigation, A11y, Zoom]);

export function Images({
  image,
  images = [],
  alt = "",
}: {
  image: string;
  images: NonNullable<ItemBySlugQuery["itemBySlug"]>["imgVariantUrls"];
  alt?: string;
}): JSX.Element {
  const options: SwiperOptions = {
    passiveListeners: false,
    slidesPerView: 1,
    navigation: {
      nextEl: "#images-next-slide",
      prevEl: "#images-prev-slide",
    },
    zoom: true,
  };

  const allImages = [
    image,
    ...(images
      ? images
          .sort((a, b) => (a?.pos || 0) - (b?.pos || 0))
          .map((item) => item?.src)
      : []),
  ];

  return (
    <div>
      <div className={st.wrapper}>
        <div className="swiper-button-custom--prev" id="images-prev-slide" />
        <Swiper {...options} style={{ width: "100%" }}>
          {allImages.map((src) => (
            <SwiperSlide key={src} style={{ width: "100%" }}>
              <div className={st.aspectRatioWrapper}>
                <div className={cx("swiper-zoom-container", st.aspectRatio)}>
                  <ImgFromCDN
                    decoding="async"
                    srcSetLoader={getCloudflareImageSrcSet}
                    src={src || ""}
                    width={400}
                    alt={alt}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-custom--next" id="images-next-slide" />
      </div>
      <span className={st.tip}>Double-tap or pinch image to zoom.</span>
    </div>
  );
}
